export const initialState = () => ({
	products: {},
	customerData: {},
	entitlements: {},
	usageHistory: {},
	usageAnalytics: {},
	subscriptions: {},
	paymentMethod: {},
	pricingPreview: {},
	paymentMethods: [],
	entitlementPlans: {},
	isAnnuallyPlan: false,
	subscriptionHistory: {},
	organizationSettings: {},
	overagesEstimatedCost: {},
	defaultPaymentMethodId: null,
	entitlementsLastRefresh: null,
	entitlementsIsRefreshing: false,
	productAutomatedSubscriptionChanges: {},
});

const state = initialState();

export default state;
